import { render, staticRenderFns } from "./ProjekterfassungtableProjekt.vue?vue&type=template&id=967bcf64"
import script from "./ProjekterfassungtableProjekt.vue?vue&type=script&lang=js"
export * from "./ProjekterfassungtableProjekt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports